import axios from '../../utils/axios';

export const termsApi = {
  getAllTerms: (page, limit) => {
    return axios.get(`/terms/list-all?limit=${limit}&page=${page}`);
  },
  createTerm: (termData) => {
    return axios.post('/terms/create', termData);
  },
  deleteTerm: (termId) => {
    return axios.delete(`/terms/${termId}`);
  },
  updateTerm: (termId, termData) => {
    return axios.patch(`/terms/${termId}`, termData);
  },
  getTermDetails: (termId) => {
    return axios.get(`/terms/${termId}`);
  }
};
